module.exports = __webpack_public_path__ + "img/symbol_8.3f76ef1a.png";